import { render, staticRenderFns } from "./chargesRemoveButton.vue?vue&type=template&id=6ebc1ade"
import script from "./chargesRemoveButton.vue?vue&type=script&lang=js"
export * from "./chargesRemoveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports